import NextImage from "@/components/common/NextImage"
import { Row, Typography } from "antd"
import { Fragment } from "react/jsx-runtime"

const PowerBy = ({ store }: any) => {

  if (store.store_name === "keithsweatmerch") {
    return <Fragment />
  }

  if (store.platform_name === "merchfans" || store.is_my_merch == 2) {
    return (
      <Typography.Link href="https://merchfans.com">
        <Row align="bottom">
          <Typography.Text>A</Typography.Text> <NextImage hiddenSpin spin={{ styles: { wrapper: { height: 23 } } }} style={{ marginInline: '0.5rem', marginBottom: 2 }} alt="Logo merchfans in the footer" src={"/static/logo/merchfans-logo.png"} height={20} width={106} /> <Typography.Text> Experience!</Typography.Text>
        </Row>
      </Typography.Link>
    )
  }

  switch (store.is_my_merch) {
    case 0:
      return (
        <Typography.Link href="https://mpodx.com">
          <Row align="bottom">
            <Typography.Text>Powered by</Typography.Text> <NextImage hiddenSpin style={{ marginInline: '0.5rem', marginBottom: 2 }} alt="Logo mpodx in the footer" src={"/static/logo/mpodx-logo.png"} height={20} width={74} />
          </Row>
        </Typography.Link>
      )

    case 1:
      return (
        <Typography.Link href="https://mymerchfactory.com">
          <Row align="bottom">
            <Typography.Text>Powered by MyMerchFactory</Typography.Text>
          </Row>
        </Typography.Link>
      )

    default:
      return <Fragment />
  }
}

export default PowerBy